import Modal from '@/components/ui/modals';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/buttons';
import { Spinner } from '@/components/ui/forms';
import ProductCard from '../order-card';
import { Form, Formik } from 'formik';
import Input from '@/components/ui/inputFormik';
import { rateProductValidation } from '@/utils/validation/user';

const initialValues = {
  message: '',
};

function RateModal({ product, isOpen, onClose, isLoading, onRate }) {
  const t = useTranslations();

  const handleSubmit = async (values, { setSubmitting }) => {
    await onRate(values?.message || '');
    setSubmitting(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('user.rate_product_key')}
      maxWidth='lg:max-w-[630px] max-sm:max-w-11/12 max-md:max-w-[450px] max-lg:max-w-[500px]'
      headerTitleClassName='pt-[13px] pb-[15px] max-sm:px-[15px] max-md:px-[25px] max-lg:px-[31px] lg:px-[37px]'
      titleClassName='!font-bold text-xl max-sm:text-base max-lg:text-lg'
      closeClassName='max-sm:size-5 max-md:size-6'
    >
      <div className='max-lg:px-[31px] max-md:px-[25px] max-sm:px-[15px] lg:px-[37px]'>
        <div className='my-6 max-lg:my-5 max-sm:my-4'>
          <ProductCard product={product} fromRateModal />
        </div>
        <div className='pb-[29px] max-lg:pb-5 max-md:pb-3 max-sm:pb-2.5'>
          <Formik
            initialValues={initialValues}
            validationSchema={rateProductValidation(t)}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form method='POST'>
                <Input
                  name='message'
                  rows={5}
                  as='textarea'
                  labelClassName='lg:hidden'
                  inputClassName='max-lg:placeholder:text-transparent'
                  title={t('user.rate_product_key')}
                  placeholder={t('user.rate_product_key')}
                />
                <div className='mt-3 grid grid-cols-2 gap-[11px] max-md:gap-4.5'>
                  <Button
                    type='submit'
                    className='h-9 w-full text-sm'
                    disabled={isLoading || isSubmitting}
                  >
                    {t('user.rate_product_key')}
                    {(isLoading || isSubmitting) && <Spinner />}
                  </Button>
                  <Button
                    type='button'
                    onClick={onClose}
                    className='h-9 w-full border border-black bg-white text-sm !text-black'
                  >
                    {t('common.cancel_key')}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  );
}

export default RateModal;
